import axios from 'axios';
import { GLOBAL_AVAILABILITY_API_BASE } from '../env';

const axiosInstance = axios.create({ baseURL: GLOBAL_AVAILABILITY_API_BASE, withCredentials: false });

export default class RsGlobalAvailabilityApi {
  constructor(token) {
    this.token = token;
  }
  async getGlobalAvailability(payload) {
    const response = await axiosInstance.get('/v4', {
      params: payload,
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    });

    return response.data;
  }
}



// WEBPACK FOOTER //
// ./src/api/globalAvailability.js